<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width payment-type-select"
               :value="value"
               :loading="loading"
               @change="onChange"
               :placeholder="$t('generic.select')"
               :value-key="valueKey"
               v-bind="$attrs">
      <el-option v-for="payment in paymentTypes"
                 class="select-default"
                 :key="payment.id"
                 :label="payment.name"
                 :value="payment"
                 :disabled="isDisabledOption(payment)"
      >
        <div class="d-flex justify-content-between">
          <span>{{payment.name}}</span>
          <b v-if="payment.type === 'credit'">
            {{creditsAmount}} / {{creditsBalance}}
          </b>
          <b v-if="payment.type === 'contract'">
            1 / {{contractsBalance}}
          </b>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import PaymentTypeService from 'src/services/PaymentTypeService'

  export default {
    name: 'payment-type-select',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: [String, Number, Object]
      },
      label: {
        type: String
      },
      creditsAmount: {
        type: [Number, Object],
        default: null
      },
      creditsBalance: {
        type: [Number, Object],
        default: null
      },
      contractsBalance: {
        type: [Number, Object],
        default: null
      },
      allowDisabledOptions: {
        type: Boolean,
        default: true
      },
      valueKey: {
        type: String,
        default: 'id'
      },
      paymentTypeFilter: {
        type: Function,
        default: types => types
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        paymentTypes: []
      }
    },
    methods: {
      onChange (val) {
        this.$emit('change', val)
      },
      isDisabledOption(payment) {
        if (!this.allowDisabledOptions) {
          return
        }
        let disabled = false
        if (payment.type === 'contract') {
          disabled = this.contractsBalance < 1
        } else if (payment.type === 'credit') {
          disabled = this.creditsAmount > this.creditsBalance
        }
        if (disabled && this.value.id === payment.id) {
          // if option is invalid and selected, reset it
          this.$emit('change', {})
        }
        return disabled
      }
    },
    async created () {
      try {
        this.loading = true
        let {data} = await PaymentTypeService.get()
        if (this.paymentTypeFilter) {
          data = this.paymentTypeFilter(data)
        }
        this.paymentTypes = data.filter(p => p.active)
        this.$emit('values-change', data)
      } finally {
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
  .payment-type-select {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
